import React from "/vendor/react";

export default React.createContext({ topBarHeight: 0 });
